import { render, staticRenderFns } from "./view_address.vue?vue&type=template&id=0eb789f4&scoped=true&"
import script from "./view_address.vue?vue&type=script&lang=js&"
export * from "./view_address.vue?vue&type=script&lang=js&"
import style0 from "./view_address.vue?vue&type=style&index=0&id=0eb789f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb789f4",
  null
  
)

export default component.exports